// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"aad111f9","239":"1bad8e10","455":"8e067ed3","610":"d0f3c754","977":"e5f645f0"}[chunkId] + ".chunk.js";
};